export class Sort {

    sortOrden(data){
        return data.sort(function (a, b) {
            if (a.orden > b.orden) {
                return 1;
            }
            if (a.orden < b.orden) {
                return -1;
            }
            return 0;
        });
    }

   sortDESC(data){
        data.reverse();
        return data;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/domain/sort/sort.ts